// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'

/* 路由 */
import router from './router'

/* axios */
import axios from './api/request'

Vue.prototype.http = axios;


/* 重置样式 */
/*
-----------------------------------------------------------------------
	Imported CSS
-----------------------------------------------------------------------
*/
import '@/assets/css/css.css';
import '@/assets/css/css2.css';
import '@/assets/css/bootstrap.min.css';
import '@/assets/css/icofont.css';
import '@/assets/css/aos.css';
import '@/assets/css/swiper.min.css';
import '@/assets/css/plugin-collection.css';
import '@/assets/css/style.css'

/* jquery */
import 'jquery'

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js